import React, { useState } from 'react';
import { Div, DivProps, P, Button } from '@kizi/core-components';
import { MobileLayover } from './MobileLayover';
import { useField } from '@kizi/comparator-core';

export interface PersonalDataMinimizedProps extends DivProps {
  preview: string;
  title: string;
}

const Flex = (props) => <Div display="flex" {...props} />;
const ButtonComp = (props) => (
  <Button variant="transparent" fontSize={[2, 2]} pl={1} {...props}>
    Meer
  </Button>
);

export const PersonalDataMinimized: React.FC<PersonalDataMinimizedProps> =
  React.forwardRef<HTMLDivElement, PersonalDataMinimizedProps>(
    ({ preview, title, children, ...divProps }, ref) => {
      const [showData, setShowData] = useState(false);
      const toggleLayOver = () => setShowData(!showData);

      return (
        <>
          <Div variant="primaryCard" padding={3} ref={ref} {...divProps}>
            <Flex
              flexDirection="row"
              alignItems="flex-start"
              justifyContent="space-between"
            >
              <P variant="ellipsed">{preview}</P>
              <ButtonComp onClick={toggleLayOver} />
            </Flex>
          </Div>
          <MobileLayover show={showData} onClose={toggleLayOver} title={title}>
            {children}
          </MobileLayover>
        </>
      );
    }
  );

export const PersonalDataMinimizedWrapper: React.FC<PersonalDataMinimizedProps> =
  ({ preview, children, title, ...divProps }) => {
    const field = useField(preview);
    if (field === undefined) return null;

    return (
      <PersonalDataMinimized
        preview={field.value as string}
        title={title}
        {...divProps}
      >
        {children}
      </PersonalDataMinimized>
    );
  };
